module.exports = __webpack_public_path__ + "img/logo-fa-left-dark.da8abc6.svg";